<template>
    <div>
        <slot :model="model"></slot>
    </div>
</template>
<script>
    import Hub from '../../hub.js';
    import * as types from '../../store/types.js';
    import * as url from '../../utils/url.js';
    
    const urlParams = url.getQueryParameters();

    export default {
        name: 'dm-login-user',
        computed: {
            model() {
                return this.$store.state.user;
            }
        },
        created() {
            Hub.subscribe(Hub.ACCOUNT_LOGIN_SUCCESS, () => {
                this.fetchUserData();
            });
        },
        methods: {
            fetchUserData() {
                this.$store.dispatch(types.USER_FETCH_DATA, urlParams);
            },
        }
    };
</script>
